<template>
<div class="pt-2 text-start">
    <span class="badge rounded-pill bg-info me-1"> BP : <b> {{curRecordHd.BP_1}}/{{curRecordHd.BP_2}} </b> mmHg. </span>
    <span class="badge rounded-pill bg-info me-1"> Pulse : {{curRecordHd.Pulse}} bpm. </span>
    <span class="badge rounded-pill bg-info me-1"> Weight : {{curRecordHd.Weight}} kg.</span>
    <span class="badge rounded-pill bg-info me-1"> Height : {{curRecordHd.Height}} cm.</span>
    <span class="badge rounded-pill bg-info me-1"> Body temp. : {{curRecordHd.BodyTemp}} C</span>
    <span class="badge rounded-pill bg-info me-1"> SpO2 : {{curRecordHd.SpO2}} %</span>
    <br><span class="badge rounded-pill bg-secondary me-1"> Specimen : {{curRecordHd.Specimen}}</span>
    <br>เอกสาร : <b> {{curRecordHd.RONo}} </b> ชื่อ : <b>{{curRecordHd.PatName}}</b> นามสกุล : <b>{{curRecordHd.PatLName}}</b>
    <br>หมายเหตุ : {{curRecordHd.Remark}}
    <form @submit.prevent="">
        <table id="myAppvResultTable" class="table table-sm table-hover table-striped table-bordered" style="width: 100%;">
            <thead class="text-white" style="background:Navy">
            <tr>
                <th>ชุดตรวจ</th>
                <th>เทส</th>
                <th></th>
                <th>เครื่องหมาย</th>
                <th>ผลแล็บ</th>
                <th>ตรวจซ้ำ</th>
                <th>หน่วย</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in datalists" :key="item.RODtl2ID" class="my-edit-tr">
                <!-- id และ ValueType : สำหรับใช้เป็น key ในการบันทึกผลและแยกประเภทข้อมูลแต่ละเทส -->
                <input type="text text-info" hidden class="form-control my-edit-input" name="id" :value="item.RODtl2ID">
                <input type="text text-info" hidden class="form-control my-edit-input" name="ValueType" :value="item.ValueType">

                <td class="text-start ">
                  <span class="badge bg-secondary me-1">{{item.RoomtypeName}}</span>
                  <span style="font-size:80%">{{ item.TestCode }}</span>
                  <span class="text-danger ms-1" style="font-size:80%;" v-if="item.PropackName"><br> {{item.PropackName}} </span>
                </td>
                <td class="text-start " v-if="(item.PrintUL==0)"> &nbsp; {{ item.ItemTestName }}</td>
                <td class="text-start " v-else><b>{{ item.ItemTestName }}</b></td>
                <td class="text-center">{{ _getHighLowSign(item) }}</td>
                <td class="text-start px-3">  {{item.PrefixResult}}    </td>
                <td class="text-start text-primary" v-if="item.ValueType == 0"><b>{{ FormatNumResult(item) }}</b> </td>
                <td class="text-start text-primary" v-if="item.ValueType == 1"><b>{{ item.ResultText }}</b> </td>
                <td class="text-start text-primary" v-if="item.ValueType == 2"><b>{{ item.Result }}</b> </td>
                <td class="text-center"> {{ arrRepeatChk[datalists[index].RepeatChecked] }}
                </td>
                <td class="text-start">{{ item.Unit }} </td>
            </tr>
            </tbody>
        </table>
    </form>
    <button class="btn btn-success mb-2" v-if=" curRecordHd.Status == 2" @click="approveRecord()">ยืนยันผลแล็บ</button>
    <br>
</div>
</template>

<script>
// import axios from 'axios'
import myfuncs from '../myjs/myfuncs.js'
import funcRO from '../myjs/funcRO.js'
import { MyApiClient } from '../myjs/my-api-client.js'
// // ****** Bootstrap and jQuery libraries ******
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// // ****** Datatable Modules *******
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition
    }
  },
  name: 'LabApprove2Appv',
  data () {
    return {
      arrRepeatChk: ['', 'R'],
      datalists: null,
      curRecordHd: {
        BranchID: 0,
        ROID: 0,
        RONo: '',
        DocDate: null,
        DocTime: null,
        PatID: 0,
        PatName: '',
        PatLName: '',
        IDNo: '',
        ReqClinicID: 0,
        HNNo: '',
        OfficerID1: 0,
        OfficerName1: '',
        Remark: '',
        TotalAmt: 0.0,
        DiscRate: 0.0,
        DiscAmt: 0.0,
        TotalAmt_BfVat: 0.0,
        VatRate: 0.0,
        VatAmt: 0.0,
        NetAmt: 0.0,
        PayType: 0,
        EarnestAmt: 0.0,
        Status: 0
      }
    }
  },
  props: ['dataROHead'],
  mounted () {
    // console.log(this.dataROHead)
    if (this.dataROHead == null) {
    } else {
      this.curRecordHd.ROID = this.dataROHead.ROID
      this.curRecordHd.RONo = this.dataROHead.RONo
      this.curRecordHd.PatName = this.dataROHead.PatName
      this.curRecordHd.PatLName = this.dataROHead.PatLName
      this.curRecordHd.IDNo = this.dataROHead.IDNo
      this.curRecordHd.Sex = this.dataROHead.Sex
      this.curRecordHd.Status = this.dataROHead.Status
      this.curRecordHd.Remark = this.dataROHead.Remark

      this.curRecordHd.Weight = this.dataROHead.Weight
      this.curRecordHd.Height = this.dataROHead.Height
      this.curRecordHd.Pulse = this.dataROHead.Pulse
      this.curRecordHd.BodyTemp = this.dataROHead.BodyTemp
      this.curRecordHd.BP_1 = this.dataROHead.BP_1
      this.curRecordHd.BP_2 = this.dataROHead.BP_2
      this.curRecordHd.SpO2 = this.dataROHead.SpO2
      this.curRecordHd.Specimen = this.dataROHead.Specimen
      this.getLabResultData()
    }
  },
  components: {

  },
  methods: {
    // =========================
    // ใช้ฟังก์ชั่นจากไฟล์ร่วม .js
    FormatNumResult (row) {
      return myfuncs.FormatNumResult(row)
    },
    _getHighLowSign (row) {
      return funcRO.getHighLowSign(row)
    },
    // =========================
    approveRecord () {
      var self = this
      Swal.fire({
        title: this.curRecordHd.RONo + '<br>' + this.curRecordHd.PatName + ' ' + this.curRecordHd.PatLName,
        text: 'คุณต้องการอนุมัติผลแล็บ..ใช่หรือไม่?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ใช่! แน่ใจ',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            type: 'POST',
            url: this.http_baseurl + 'setdata/appv_ro_labresult.php',
            data: { ROID: this.curRecordHd.ROID, UserID: self.globalUserID }
          }).done(function () {
            Swal.fire({
              text: 'อนุมัติผลแล็บเรียบร้อย',
              icon: 'success',
              showConfirmButton: false,
              timer: 1500
            }).then((result) => {
              self.backPageAfterSave()
            })
          })
        }
      })
    },
    getLabResultData () {
      // MyApiClient.get('getdata/labrequest_all.php')
      MyApiClient.get('getdata/labresult_where.php?id=' + this.curRecordHd.ROID)
        .then((resp) => {
          console.log(resp.data.response)
          this.datalists = resp.data.response
        //   setTimeout(function () { $('#myEntryResultTable').DataTable() }, 0)
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    backPageAfterSave () {
      this.$emit('onBackPageAfterSaveEvent')
    }
  }
}
</script>

<style>

</style>
